export const ROUTE_CONSTANTS = {
    HOME: '',
    SESSION: 'session',
    SESSIONS: 'sessions',
    CALENDAR: 'calendar',
    SQUAD: 'squad',

    ADMIN: {
        ROOT: 'admin',

        DATASET: 'dataset',
        TEAM: 'team',
        USERS: 'users',
        ANALYTICS: 'analytics',
        INSIGHTS: 'insights',
        SUPPORT: 'support',
        LEGAL: 'legal',
        BLOG: 'blog',
        DATA_SYNC: 'data-sync',

        VECTOR_TEST: {
            ROOT: 'vector-test',
            LIST: 'list',
            CREATE: 'create',
        },
    },

    AUTH: {
        ROOT: 'auth',

        LOGIN: 'login',

        REGISTER: 'register',
        REGISTER_SUCCESS: 'success',

        FORGOT_PASSWORD: 'reset',
        FORGOT_NEW_PASSWORD: ':id',
        RESET_SUCCESS: 'success',
        RESET_EXPIRED: 'expired',

        CONFIRM_EMAIL: 'confirm',
        CONFIRM_TOKEN: ':token',
        CONFIRM_SUCCESS: 'success',

        DISABLED: 'disabled',

        LOGOUT: 'logout',
    },

    USER: {
        ROOT: 'profile',

        ACCOUNT: 'account',
        BILLING: 'billing',
        SETTINGS: 'settings',

        DELETE_ACCOUNT: 'delete-account',
    },

    FORBIDDEN: 'forbidden',

    LEGAL: {
        ROOT: 'legal',

        // - Widerrufsrecht
        CANCELLATION_RIGHT: 'cancellation-right',
        // - AGB
        TERMS: 'terms',
        // - Impressum (kleine Anpassung)
        IMPRINT: 'imprint',
        // - Versandbedingungen
        SHIPPING_CONDITIONS: 'shipping-conditions',
        // - Datenschutz
        PRIVACY: 'privacy',
    },
};
